<script setup>
import { ref } from "vue";
import Login from "views/Login";
import Register from "views/Register";
import Reset from "views/Reset";

const props = defineProps(["email"]);
const emit = defineEmits(["login", "update:busy"]);

const activeComponent = ref("Login");
const cachedEmail = ref(props.email);
const components = {
	Login,
	Register,
	Reset
};

function login(email) {
	emit("login", email);
}
</script>

<template>
	<component
		:is="components[activeComponent]"
		v-model:cached-email="cachedEmail"
		:readonly-email="Boolean(email)"
		@active-component="activeComponent = $event"
		@login="login"
		@update:busy="$emit('update:busy', $event)"
	/>
</template>
